import { render, staticRenderFns } from "./ApplicantMovements.vue?vue&type=template&id=09a90849&scoped=true&"
import script from "./ApplicantMovements.vue?vue&type=script&lang=js&"
export * from "./ApplicantMovements.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantMovements.vue?vue&type=style&index=0&id=09a90849&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a90849",
  null
  
)

export default component.exports